// RowFeeCategoryActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowFeeCategoryActionsMenu = ({
  row,
  onEdit,
  onDelete,
  onCreateFeeType,
  onViewFeeTypes,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  // Inactive if status is INACTIVE
  const isInactive = row.status === "INACTIVE";

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit(row);
              handleClose();
            }}
          >
            Edit Fee Category
          </MenuItem>
        )}
        {hasPermission("delete") && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onDelete(row.fee_category_id);
              handleClose();
            }}
          >
            Delete Fee Category
          </MenuItem>
        )}
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateFeeType(row.fee_category_id, row.fee_category_name, row.client_id);
            handleClose();
          }}
        >
          Create Fee Type
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewFeeTypes(row.fee_category_id, row.fee_category_name, row.client_id);
            handleClose();
          }}
        >
          View Fee Types
        </MenuItem>
      </Menu>
    </>
  );
};

RowFeeCategoryActionsMenu.propTypes = {
  row: PropTypes.shape({
    fee_category_id: PropTypes.number.isRequired,
    fee_category_name: PropTypes.string.isRequired,
    client_id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired, // "ACTIVE" or "INACTIVE"
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateFeeType: PropTypes.func.isRequired,
  onViewFeeTypes: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};

export default RowFeeCategoryActionsMenu;
